import PropTypes from "prop-types"
import { upperFirst, map } from "lodash"
import { Card, MenuItem, Select, InputLabel } from "@mui/material"

export default function UploadHeader({ type = "portfolio", target, rolloverLegend, editableModel, models, setModel }) {
  return <Card elevation={1} square className="upload-card upload-target-detail">
    <div className="upload-target-name">
      {upperFirst(type)}<div className="detail-value">{target.name}</div>
    </div>
    <div className="upload-target-modelId">
      {!editableModel && target.model && <>Model <div className="detail-value">{target.model}</div></>}
      {editableModel
        && <>
          <InputLabel htmlFor="modelId">Select a model</InputLabel>
          <Select
            variant="standard"
            id="modelId"
            className="model-selector"
            value={target.modelId}
            onChange={setModel}
          >
            {map(models, (model, i) =>
              <MenuItem key={i} value={model.id}>{model.name}</MenuItem>,
            )}
          </Select>
        </>}
    </div>
    {rolloverLegend && <div className="upload-target-live">
      {rolloverLegend}
    </div>}
  </Card>
}

UploadHeader.propTypes = {
  type: PropTypes.string.isRequired,
  target: PropTypes.object.isRequired,
  editableModel: PropTypes.bool,
  models: PropTypes.array,
  setModel: PropTypes.func,
  rolloverLegend: PropTypes.string,
}
